import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e4a50b6753f713af0aa80c577fe5a8027ea632b55ab1287fc646905f283ff047.cfe-internal.js';
import { useFormFieldContext } from '../FormField/ff8bdfb918b98e400d01f1272050447aed13a9c7dbe824884d42b110edddae42.cfe-internal.js';
import concatIds from '../../utils/concatIds/4f58d37595ecc5912f64ecb84828b103f66a43e895e850434f09170560f4b3d7.cfe-internal.js';

var _excluded = ["id", "className", "checked", "defaultChecked", "disabled", "onChange", "value", "inputProps", "aria-label", "aria-labelledby", "aria-describedby", "tabIndex"];
var Switch = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      value = _ref.value,
      inputProps = _ref.inputProps,
      ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'],
      externalAriaDescribedBy = _ref['aria-describedby'],
      tabIndex = _ref.tabIndex,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormFieldContext = useFormFieldContext(),
      formFieldHelperTextId = _useFormFieldContext.helperTextId,
      formFieldErrorTextId = _useFormFieldContext.errorTextId;

  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId, inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-describedby']);
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles["switch"], _defineProperty({}, styles.disabled, disabled))
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    className: classNames(styles.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
    type: "checkbox",
    role: "switch",
    id: id !== null && id !== void 0 ? id : inputProps === null || inputProps === void 0 ? void 0 : inputProps.id,
    checked: checked !== null && checked !== void 0 ? checked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.checked,
    defaultChecked: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.defaultChecked,
    disabled: disabled !== null && disabled !== void 0 ? disabled : inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled,
    onChange: disabled ? undefined : onChange !== null && onChange !== void 0 ? onChange : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange,
    value: value !== null && value !== void 0 ? value : inputProps === null || inputProps === void 0 ? void 0 : inputProps.value,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-label'],
    "aria-labelledby": ariaLabelledBy !== null && ariaLabelledBy !== void 0 ? ariaLabelledBy : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-labelledby'],
    "aria-describedby": internalAriaDescribedby,
    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : inputProps === null || inputProps === void 0 ? void 0 : inputProps.tabIndex
  })), /*#__PURE__*/React__default.createElement("span", {
    className: styles.slider
  }));
});
var Switch$1 = Switch;

export { Switch$1 as default };
